import { v4 as uuid } from "uuid";
function resolveOnSuccessOrTimeout(succeededCallback, resolveCallback, rejectCallback, retryFrequency, timeout) {
    let isDone = false;
    // success
    setTimeout(() => {
        if (!isDone) {
            if (succeededCallback()) {
                isDone = true;
                resolveCallback();
            }
            else {
                resolveOnSuccessOrTimeout(succeededCallback, resolveCallback, rejectCallback, retryFrequency, timeout);
            }
        }
    }, retryFrequency);
    // fail
    setTimeout(() => {
        if (!isDone) {
            isDone = true;
            rejectCallback();
        }
    }, timeout);
}
// cross platform base64 operations
// @ts-ignore
const encB64 = btoa || ((str) => Buffer.from(str).toString("base64"));
// @ts-ignore
const decB64 = atob || ((str) => Buffer.from(str, "base64").toString());
export class Util {
    static uuidgen(postfix) {
        return postfix ? uuid() + "-" + postfix : uuid();
    }
    static delay(millis) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), millis);
        });
    }
    static waitUntil(succeededCallback, frequency = 200, timeout = 5000) {
        return new Promise((resolve, reject) => {
            resolveOnSuccessOrTimeout(succeededCallback, resolve, reject, frequency, timeout);
        });
    }
    static encodeToBase64(data) {
        return encB64(data);
    }
    static decodeFromBase64(encodedData) {
        return decB64(encodedData);
    }
}
